<script setup lang="ts">
import { X } from 'lucide-vue-next';

import { useToastStore } from '@/stores/toast';

const toasts = useToastStore();
</script>

<template>
  <div class="pointer-events-none fixed right-4 bottom-4 z-50 flex w-80 flex-col gap-2">
    <TransitionGroup
      enter-from-class="translate-y-2 opacity-0"
      enter-active-class="transition duration-150"
      leave-to-class="opacity-0"
      leave-active-class="transition duration-150"
    >
      <div
        v-for="toast in toasts.toasts"
        :key="toast.id"
        class="pointer-events-auto flex items-start gap-3 rounded-md border bg-white px-3 py-2.5 text-sm shadow-lg"
        :class="{
          'border-stone-200 text-stone-700': toast.tone === 'info',
          'border-verdict-pass/30 text-verdict-pass': toast.tone === 'success',
          'border-verdict-fail/30 text-verdict-fail': toast.tone === 'error',
        }"
        role="status"
      >
        <span class="flex-1">{{ toast.message }}</span>
        <button class="text-stone-400 hover:text-stone-700" @click="toasts.dismiss(toast.id)">
          <X class="size-4" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
